import { runInAction } from "mobx";
import PatientsStore, { PATIENT_SUBTABS } from "./patientsStore";
import { navigateWithProjection } from "../../helpers/searchParams/navigateWithProjection";
import type { NavigateFunction } from "react-router-dom";

export type PatientCommandsType = {
  handleOpenPatient: (patientId: number, rxId?: string) => void;
  selectRx: (rxId: string) => void;
  selectSeries: (seriesId: string) => void;
  navigateToPatient: (navigate: NavigateFunction, patientId: number | undefined, rxId: string | null, rxsubTab?: PATIENT_SUBTABS | string, extra?: Partial<PatientsStore>) => void;
};

export const PatientCommands = (patientsStore: PatientsStore): PatientCommandsType => {
  const handleOpenPatient = (patientId: number, rxId?: string) => {
    runInAction(() => {
      patientsStore.setSelectedPatientId(patientId);
      patientsStore.setSelectedRxId(rxId || null);
      if (rxId) {
        patientsStore.setSelectedSubTabStr(PATIENT_SUBTABS.PRESCRIPTIONS)
      }
    });
  };

  const selectRx = (rxId: string) => {
    runInAction(() => {
      patientsStore.setSelectedRxId(rxId);
      // Clear series selection when RX is selected
      patientsStore.setSelectedSeriesId(undefined);
      patientsStore.setSelectedSubTabStr(PATIENT_SUBTABS.PRESCRIPTIONS);
    });
  };

  const selectSeries = (seriesId: string) => {
    runInAction(() => {
      patientsStore.setSelectedSeriesId(seriesId);
      // Clear RX selection when series is selected
      patientsStore.setSelectedRxId(null);
      patientsStore.setSelectedSubTabStr(PATIENT_SUBTABS.PRESCRIPTIONS);
    });
  };

  /**
   * Unified navigation into the patient route using projection semantics.
   * - If the patient store is already hydrated, we just mutate the store (URL will update via projection autorun) and navigate to base route.
   * - If not hydrated yet (first transition in a fresh session), we build a query string so hydration can pick it up.
   */
  const navigateToPatient = (
    navigate: NavigateFunction,
    patientId: number | undefined,
    rxId: string | null,
    subTab?: PATIENT_SUBTABS | string,
    extra?: Partial<PatientsStore>
  ) => {
    navigateWithProjection(patientsStore, navigate, {
      ctor: patientsStore.constructor,
      patch: {
        selectedPatientId: patientId as any,
        selectedRxId: rxId as any,
        ...(subTab ? { selectedSubTabStr: subTab as any } : {}),
        ...(extra || {}),
      },
    });
  };

  return {
    handleOpenPatient,
    selectRx,
    selectSeries,
    navigateToPatient,
  };
};
